import { get } from "lodash";
import { useMemo } from "react";
import { useTranslate } from "ra-core";

const Title = ({ record, action = "create" }) => {
  const translate = useTranslate();
  const type = useMemo(() => get(record, "type"), [record]);
  const title = translate(
    `resources.research-project-staff-users.title.${action}.${type}`,
    record
  );
  return title;
};
export default Title;
